import ApiResource from 'resources/ApiResource'

export default class RegistrationResource extends ApiResource {
  static urlRoot = '/auth/registration' as const;

  readonly auth_token: string = '';

  pk() {
    return this.auth_token?.toString();
  }

}
